"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenMobileModel = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const AbstractTokenModel_1 = require("../Model/AbstractTokenModel");
class TokenMobileModel extends AbstractTokenModel_1.AbstractTokenModel {
    parseToken(token) {
        return (0, jwt_decode_1.default)(token);
    }
}
exports.TokenMobileModel = TokenMobileModel;
//# sourceMappingURL=TokenMobileModel.js.map